<script setup lang="ts">
import { onBeforeMount, ref, useAttrs } from "vue";

import { TcLoader } from "../UI";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

export interface TcSuspenseProps {
  asyncCall?: () => Promise<unknown>;
  isLoading?: boolean;
  isCenterLoader?: boolean;
}

const isLoaded = ref<boolean>(false);

const props = withDefaults(defineProps<TcSuspenseProps>(), { isLoading: false, isCenterLoader: true });
const attrs: Record<string, unknown> = useAttrs();

onBeforeMount(async () => {
  if (hasValue(props.asyncCall)) {
    isLoaded.value = false;

    await props.asyncCall();
  }

  isLoaded.value = true;
});
</script>

<template>
  <template v-if="!hasValue(attrs.class) || !isValidString(attrs.class)">
    <slot name="header" />

    <slot v-if="isLoaded && !props.isLoading" />

    <slot name="loader" v-else>
      <TcLoader :center="props.isCenterLoader" />
    </slot>
  </template>

  <div v-else :class="attrs.class">
    <slot name="header" />

    <slot v-if="isLoaded && !props.isLoading" />

    <slot name="loader" v-else>
      <TcLoader :center="props.isCenterLoader" />
    </slot>
  </div>
</template>
